module.exports = __webpack_public_path__ + "static/media/FAQ.8cbdb8b0.md";